import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./scss/index.scss";
import Auth from "./Pages/Auth/Auth";
import { startActivityWatcher } from "./Common/Client/ActivityWatcher";
import { startTokenMonitor } from "./Common/Client/TokenMonitor";
import { startKeepSessionAlive } from "./Common/Client/KeepSessionAlive";
import useGTM from "./Components/GTM";
import useScrollDepthTracking from "./hooks/useScrollDepthTracking";
import useLogoutSync from "./hooks/useLogoutSync";
import { useSelector } from "react-redux";
import UnauthorizedAccessModal from "./Components/Common/UnauthorizedAccessModal";

const App = () => {
  const gtmId = process.env.REACT_APP_GTM_ID || "GTM-XXXXXXX";
  const clientConfig = useSelector((state) => state.clientConfigurationReducer);
  const loginToken = useSelector((state) => state.validateLoginTokenSliceReducer);
  useGTM(gtmId);
  useScrollDepthTracking();
  useLogoutSync();

  // Start activity watcher and token monitor once SSO login populates sessionStorage.
  // Polling is necessary here because sessionStorage is written by SsoLogin (a child
  // route) and is not reactive — no Redux signal exists at this layer.
  useEffect(() => {
    let monitor;

    const check = setInterval(() => {
      const login = sessionStorage.getItem("login");
      const expiry = sessionStorage.getItem("expirytime");
      const minutes = sessionStorage.getItem("expiryTimeInMintue");

      if (login === "true" && expiry && minutes) {
        clearInterval(check);
        const disableSessionManagement = clientConfig?.clientConfigurationData?.[0]?.clientConfig?.some(
          (config) => config.configKey === "disableInternalUserSessionManagement" && config.configValue === "1"
        );
        if (!disableSessionManagement) {
          startActivityWatcher();
        }
        monitor = startTokenMonitor(disableSessionManagement);
      }
    }, 300);

    return () => {
      clearInterval(check);
      if (monitor) clearInterval(monitor);
    };
  }, [clientConfig]);

  // Keep session alive only once on initial load
  useEffect(() => {

    const keepAlive = startKeepSessionAlive(loginToken?.data?.partnerSessionToken);
    return () => {
      if (keepAlive) clearInterval(keepAlive);
    };
  }, [loginToken]);

  return (
    <BrowserRouter>
      <Auth />
      <UnauthorizedAccessModal />
    </BrowserRouter>
  );
};

export default App;
